<template>
    <a-modal title="自定义群组"
             :width="800"
             :visible="visible"
             @ok="onSave"
             @cancel="onCancel"
             :confirmLoading="confirmLoading">
        <a-form :form="form">
          <a-form-item
              label='群组名称'
              :labelCol="{ span: 5 }"
              :wrapperCol="{ span: 12 }">
            <a-input v-decorator="[
                            'groupName',
                            {rules: [{ required: true, message: '请填写群组名称' }]}]" placeholder='群组名称'/>
          </a-form-item>
          <a-form-item
              label='顺序号'
              :labelCol="{ span: 5 }"
              :wrapperCol="{ span: 12 }">
            <a-input-number v-decorator="[
                                    'seqNo',
                                    {rules: [{ required: true, type: 'number', message: '请填写数字类型顺序号' }]}]" placeholder='顺序号'/>
          </a-form-item>
          <a-form-item
              label='群组成员'
              :labelCol="{ span: 5 }"
              :wrapperCol="{ span: 14 }">
            <user-selector v-decorator="['groupIds']" multiple selectAllButton showRoot style="width: 100%"/>
          </a-form-item>
        </a-form>
    </a-modal>
</template>

<script>
import qs from 'qs'
import UserSelector from '@/components/selector/UserSelector'

export default {
  name: 'LocalGroupAdd',
  components: {
    UserSelector
  },
  data () {
    return {
      form: this.$form.createForm(this),
      confirmLoading: false,
      visible: false
    }
  },
  methods: {
    preGroupAdd: function () {
      this.visible = true
      this.form.resetFields()
    },
    onSave () {
      this.form.validateFields((err, values) => {
        if (err) {
          return
        }
        this.confirmLoading = true
        let params = this.form.getFieldsValue()
        this.$http.post('/api/1/workflow/local_group/add_local_group.json', qs.stringify(params)).then((resp) => {
          this.confirmLoading = false
          this.visible = false
          this.$emit('success')
        })
      })
    },
    onCancel () {
      this.visible = false
      this.$emit('cancel')
    }
  }
}
</script>

<style scoped>

</style>
